import React from 'react';
import classnames from 'classnames';

import { Section, Layout, SEO } from '..';

import manualDevice from './assets/manualDevice.png';
import manualNotes from './assets/manualNotes.png';

import arrow from './assets/arrow.png';
import arrowOptional from './assets/arrowOptional.png';
import dollar from './assets/dollar.png';
import peopleCalling from './assets/peopleCalling.png';
import player from './assets/player.png';

import style from './HowToPlayPage.module.less';

export const HowToPlayPage = () => (
  <Layout>
    <SEO title="How to play" />

    <Section className={classnames(style.section, style.firstSection)}>
      <div className={style.content}>
        <h1>How to play</h1>

        <div className={style.contentNarrow}>
          <div className={style.arrow}>
            <img src={arrow} alt="Arrow 1" />
            <span>1</span>
          </div>
          <h2>Purchase one code for the whole team</h2>
          <div className={style.text}>
            You pay the same price regardless of your team size. Pay once, share your License Key with others and have fun!
          </div>
          <div className={style.images}>
            <img src={dollar} alt="Dollar" className={style.dollar} />
          </div>
        </div>

        <div className={style.contentNarrow}>
          <div className={style.arrow}>
            <img src={arrow} alt="Arrow 2" />
            <span>2</span>
          </div>
          <h2>Use at least two devices</h2>
          <div className={style.text}>
            It's a split-puzzle game, which means that players will interact with different clues to the puzzles. Communication is key.
          </div>
          <div className={style.images}>
            <img src={manualDevice} alt="Manual device" className={style.manualDevice} />
          </div>
        </div>

        <div className={style.contentNarrow}>
          <div className={style.arrow}>
            <img src={arrow} alt="Arrow 3" />
            <span>3</span>
          </div>
          <h2>Go to the game link and enter the code on each device</h2>
          <div className={style.text}>
            Each of the players should use the same License Key. That's how the game will know that you play together!
          </div>
          <div className={style.images}>
            <img src={player} alt="Screenshot" className={style.screenshot} />
          </div>
        </div>

        <div className={style.contentNarrow}>
          <div className={style.arrow}>
            <img src={arrowOptional} alt="Arrow 4" />
            <span>4</span>
            <p className={style.optional}>OPTIONAL</p>
          </div>
          <h2>If you play remotely, establish communication channel</h2>
          <div className={style.text}>
            You can play remotely with friends or family using programs such as Skype, Zoom, Google Hangouts etc. No need to share your screen, only a voice communication is required.
          </div>
          <div className={style.images}>
            <img src={peopleCalling} alt="People calling" className={style.peopleCalling} />
          </div>
        </div>

        <div className={style.contentNarrow}>
          <div className={style.arrow}>
            <img src={arrowOptional} alt="Arrow 5" />
            <span>5</span>
            <p className={style.optional}>OPTIONAL</p>
          </div>
          <h2>Prepare pen, paper and some crisps</h2>
          <div className={style.text}>
            Once you have a team, some writing tools, and your brain ready to go, then it’s time to get comfy, maybe grab some drinks and snacks, and immerse yourself in the game!
          </div>
          <div className={style.images}>
            <img src={manualNotes} alt="Notes and food" className={style.manualNotes} />
          </div>
        </div>
      </div>
    </Section>
  </Layout>
);
